import React, { useRef, useEffect } from "react";
import { Box, Typography, Link } from "@mui/material";
import { buildProductUrl } from "utilities/navigation";

const FastEntryShortDescription = ({ master_short_description, selectedStyle, selectedColor }) => {
  // Add render tracking
  const renderCount = useRef(0);
  const prevPropsRef = useRef({});
  
  // Create the product URL if we have both style and color
  const dgiStyleSku = selectedStyle?.dgi_style_sku;
  const color = selectedColor || selectedStyle?.master_color || selectedStyle?.color;
  
  const productUrl = dgiStyleSku && color ? 
    buildProductUrl(dgiStyleSku, color) : 
    null;
  
  // Add safe debugging with useEffect
  useEffect(() => {
    renderCount.current += 1;
    
    // Only log on first render or when props change significantly
    const currentProps = { master_short_description, selectedStyle, selectedColor };
    if (renderCount.current === 1 || 
        JSON.stringify(currentProps) !== JSON.stringify(prevPropsRef.current)) {
      
      // Update ref
      prevPropsRef.current = JSON.parse(JSON.stringify(currentProps));
    }
  }, [master_short_description, selectedStyle, selectedColor, dgiStyleSku, color, productUrl]);
  
  return (
    <Box 
      sx={{ 
        width: '100%', 
        padding: '0px 8px 4px 8px',
        marginLeft: '8px',
        minHeight: '20px',
      }}
    >
      {master_short_description && (
        <Typography
          variant="body2"
          sx={{
            fontSize: '0.8rem',
            color: 'text.secondary',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
          }}
        >
          {productUrl ? (
            <Link
              href={productUrl}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'inherit',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                }
              }}
            >
              {master_short_description}
            </Link>
          ) : (
            master_short_description
          )}
        </Typography>
      )}
    </Box>
  );
};

export default FastEntryShortDescription;